var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRecommendedTag = function SvgRecommendedTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 69,
    viewBox: "0 10 28 69"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EA580C",
    d: "M44 8.25H16v36l14-6 14 6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m30 29.643 5.15 3.108-1.367-5.858 4.55-3.942-5.992-.508-2.342-5.525-2.341 5.525-5.992.508 4.55 3.942-1.367 5.858z"
  })));
};
export default SvgRecommendedTag;